import React, { useMemo } from 'react';

import { SetPageStateValue } from '#src/shared/pageState';

import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';
import { useTrackView } from '#src/app/shared/hooks/tracking';

export const ActionsPageView: React.FC = () => {
	useTrackView('petition_actions_view');

	const {
		data: {
			petition: { ask, geoReach, relevantLocationLocalizedName, descriptionStripped },
		},
	} = usePetitionActionsPageData();
	const pageStatePetition = useMemo(
		() => ({ ask, geoReach, relevantLocationLocalizedName, description: descriptionStripped }),
		[ask, descriptionStripped, geoReach, relevantLocationLocalizedName],
	);

	return <SetPageStateValue name="petition" value={pageStatePetition} />;
};
